///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { initialState } from "../slices/laneMatchSlice";
import { status } from "./types";

const getDefaultLaneMatchFilters = () => {
  const laneMatchFilters = {
    ...initialState.filters,
    odhRadiusDistance: 50,
    ddhRadiusDistance: 50,
    statuses: [
      status.inProgress,
      status.submitted,
      status.feedback,
      status.closed
    ],
    monthRange: 1
  };

  return laneMatchFilters;
};

export default getDefaultLaneMatchFilters;
